import bgImage from '@assets/app-bg.png';
import { MainHeader } from '@components/features/organisms/MainHeader';
import { SideBar } from '@components/features/organisms/SideBar';
import { Flex } from '@components/ui/atoms/Flex';
import { memo, useMemo } from 'react';

export const AppLayout: React.FCWithChildren = memo((props) => {
  const backgroundStyles = useMemo(
    () => ({
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    }),
    []
  );

  return (
    <Flex
      w="full"
      h="full"
      as="main"
      position="relative"
      overflow="hidden"
      flexDirection={{ base: 'column', md: 'row' }}
      css={{
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          ...backgroundStyles,
          zIndex: 0,
        },
      }}
    >
      <SideBar />

      <Flex
        display="flex"
        flexDirection="column"
        flex="1"
        minHeight={0}
        width="full"
        height="full"
        position="relative"
        zIndex={1}
        overflowY="auto"
        overflowX="hidden"
        py="16px"
        pl={{ base: '16px', md: '20px' }}
        pr={{ base: '16px', md: '20px' }}
        css={{
          WebkitOverflowScrolling: 'touch',
          /* Android Chrome fix: ensure proper scrolling */
          overscrollBehavior: 'contain',
          /* Prevent pull-to-refresh on Android */
          touchAction: 'pan-y',
        }}
      >
        <Flex
          display="flex"
          flexDirection="column"
          gap="16px"
          width="full"
          maxWidth="100%"
          css={{
            '@media (max-width: 767px)': {
              paddingBottom: '48px !important',
            },
            '@media (min-width: 768px) and (max-width: 1023px)': {
              paddingBottom: '32px !important',
            },
          }}
        >
          <MainHeader />
          <Flex width="full" color="body.dark">
            {props.children}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
});

AppLayout.displayName = 'AppLayout';
